<!--
 * @Description:
 * @Author: Rfan
 * @Date: 2020-12-10 15:52:06
 * @LastEditTime: 2023-10-10 11:44:45
-->

<template>
  <div class="pages service">
    <div class="container">
      <p>
        <strong
          >更新时间：2023年10月10日<br />
          生效时间：2023年10月10日</strong
        >
      </p>
      <p>
        熊猫绘画付费会员自动续费服务规则（下称“本规则”）为《熊猫绘画会员服务协议》的附件，如本规则和《熊猫绘画会员服务协议》存在冲突，以本规则为准。<strong
          >除非您已阅读并接受本规则所有条款，否则请不要开通或使用本服务。如您需要使用付费会员自动续费服务，则需要同意本规则。如果您未满18周岁，请在法定监护人陪同下阅读本规则。</strong
        >
      </p>
      <p>
        <strong>1 服务说明</strong><br />
        1.1熊猫绘画付费会员自动续费服务（下称“本服务”）是在您开通付费会员的基础上，出于您对自动续费的需求，为避免您因疏忽或其他原因导致未能及时续费而推出的服务。具体续费周期包括：月度、季度、年度，您可根据自己需求自行选择。<br />
        1.2<strong
          >如果您通过苹果公司Apple
          ID开通本服务，且在下一个订阅到期前24小时未主动取消本自动续费服务，则苹果公司将在每个订阅即将到期前24消失，从您开通本服务时绑定的Apple
          ID账户余额中自动代扣下一个订阅期服务费。因部分渠道由运营商或支付渠道根据实际情况自行决定扣费周期，则前述自动续费服务的扣费时间以个渠道实际扣款日期为准</strong
        >。<br />
        <strong
          >1.3如果您通过安卓产品开通本服务，且会员到期内未主动取消自动续费服务，则相关主体将在会员到期当天或到期后，从您开通本自动续费服务时绑定的自有充值账户(如支付宝、微信)等账户余额中自动代扣下一个订阅期服务费。</strong
        ><br />
        1.4本服务实现的前提是您将付费会员账号与上述支付账户绑定，且可成功从上述账户余额中足额扣款。因上述账户中可扣款余额不足、账户本身异常导致的续费失败，由您自行承担；如果您未主动选择取消本服务，会在您账户恢复正常且余额充足时，继续为您提供自动续费服务，一旦扣款成功，将恢复您付费会员服务。<br />
        1.5请您悉知，在使用第三方支付渠道支付费用时，您还将受到该第三方服务条款、使用规则的约束。<br />
        1.6为了便于您了解自动续费情况，在下一个订阅期扣款前5日，会以邮件或短信方式发送自动续费提示，请您予以关注。
      </p>
      <p>
        <strong>2取消本服务</strong><br />
        2.1您随时可以取消本服务，如需取消自动续订，请至少提前24小时操作取消，您可通过下述方式中止或终止本服务：<br />
        <strong>2.1苹果应用内支付</strong><br />
        iOS12及以上系统：打开iOS设备“App Store”
        →点击右上角苹果账号头像→进入“账户”→点击“订阅”→选择熊猫绘画，取消订阅。<br />
        iOS12以下操作系统：打开iOS设备“设置”→进入“iTunes Store 与 App
        Store”→点击 “Apple ID”，选择&quot;查看Apple
        ID&quot;，进入&quot;账户设置&quot;页面→点击“订阅”→选择熊猫绘画，取消订阅。
      </p>
      <p>
        如果您对本规则内容有任何疑问，请通过熊猫绘画设置中心-联系客服进行反馈。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Term",
  components: {},
  computed: {},
  created() {},
  methods: {}
};
</script>

<style lang="scss">
.service {
  .container {
    font-size: 14px;
    line-height: 1.5;
  }
}
</style>
